module.exports = __webpack_public_path__ + "static/media/menuDinner.82700993.png";